import Axios from "axios";
import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import "../src/design-system/styles/main.scss";
import App from "./App";
import ErrorBoundary from "./ErrorBoundary";
import "./index.css";
import * as serviceWorker from "./serviceWorker";
import store from "./store/store";
import { initMixpanel } from "./Utils/Mixpanel/mixpanel";

// Initialize Mixpanel once on app startup
initMixpanel();

Axios.defaults.baseURL = import.meta.env.VITE_APP_NAKAD_LOCAL
  ? null
  : import.meta.env.VITE_API_BASE_URL
  ? import.meta.env.VITE_API_BASE_URL
  : import.meta.env.VITE_APP_NAKAD_ENV === "test"
  ? "https://api.dev.nakad.co"
  : import.meta.env.VITE_APP_NAKAD_ENV === "staging"
  ? "https://api.staging.nakad.co"
  : import.meta.env.VITE_APP_NAKAD_ENV === "production"
  ? import.meta.env.VITE_APP_NAKAD_ENV_TAG === "demo"
    ? "https://api.demo.nakad.co"
    : "https://api.nakad.co"
  : null;
Axios.defaults.withCredentials = true;
// Axios.defaults.baseURL = "http://localhost:8082";
ReactDOM.render(
  <React.StrictMode>
    <ErrorBoundary>
      <Provider store={store}>
        <App />
      </Provider>
    </ErrorBoundary>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
